/* eslint-disable simple-import-sort/exports */
/* eslint-disable sort-keys-fix/sort-keys-fix */
import * as Yup from 'yup';

import { useValidation } from '@/hooks/useValidation';
import { Shape } from '@/models';
import { FormSurveyModel, SupportMessage } from '@/modules/communication/models';

const { stringRequired } = useValidation('VALIDATION.FIELD.RECRUITMENT');
const { fileRequired } = useValidation('VALIDATION.FIELD.SURVEY');

function getSurveyFormSalarySchema() {
  return Yup.object<Shape<FormSurveyModel>>({
    name: stringRequired('NAME'),
    start_date: stringRequired('START_DATE'),
    end_date: stringRequired('END_DATE'),
    // QC #52 — fileRequired() only enforces "object is present" but the
    // detail page seeds the field with `{ url: '' }` for surveys that have
    // no file yet, so Yup `.required()` always passed. Add an explicit
    // non-empty test on the inner url/full_path.
    file: fileRequired('FILE_WORKER').test(
      'file-not-empty',
      'Bắt buộc đính kèm tệp',
      (value) => {
        if (!value) return false;
        const f = value as { url?: string; full_path?: string };

        return Boolean(f.url || f.full_path);
      }
    ),
  });
}
function getSurveyFormFreeSchema() {
  return Yup.object<Shape<FormSurveyModel>>({
    name: stringRequired('NAME'),
    start_date: stringRequired('START_DATE'),
    end_date: stringRequired('END_DATE'),
  });
}

function getMessageFormSchema() {
  return Yup.object<Shape<SupportMessage>>({
    message: stringRequired('MESSAGE'),
  });
}

export { getSurveyFormSalarySchema, getMessageFormSchema, getSurveyFormFreeSchema };
